const $ = window.jQuery;

const filterOurSolution = (() => {
    let domainSelect = $(".domains-select-container")
    let categorySelect = $(".category-select-container")
    let initDomainSelect = () => {
        domainSelect.select2({
            placeholder: "Select Domain",
            dropdownCssClass: "domains-container"
        }).on('select2:open', function (e) {
            $(document.body).find('.select2-dropdown.domains-container').addClass('animate-dropdown');
        }).on('select2:closing', function (e) {
            $(document.body).find('.select2-dropdown.domains-container').removeClass('animate-dropdown');
        });

        domainSelect.on('select2:select', function (e) {
            let data = e.params.data;
            let selectedDomain = $(data.element).data('domain');
            categorySelect.val('all').trigger('change');
            enableDomainCategories(selectedDomain);
        })
    }
    let checkSelectedOptions  = () => {
        let selectedDomain = $(domainSelect).val()
        if (selectedDomain == 'all') {
            categorySelect.prop("disabled", true);
        } else {
            enableDomainCategories(selectedDomain);
        }
    }
    let resultState = (data, container) => {
        if (data.element) {
            $(container).addClass($(data.element).attr("class"));
        }
        return data.text;
    }
    let initCategorySelect = () =>{
        let placeholder = categorySelect.data('placeholder')
        categorySelect.select2({
            placeholder: placeholder,
            dropdownCssClass: "category-container",
            templateResult: resultState
        }).on('select2:open', function (e) {
            $(document.body).find('.select2-dropdown.category-container').addClass('animate-dropdown');
        }).on('select2:closing', function (e) {
            $(document.body).find('.select2-dropdown.category-container').removeClass('animate-dropdown');
        });
    }
    let enableDomainCategories = (domain) => {
            categorySelect.prop("disabled", true);
            document.querySelectorAll('.category-select-container option[data-domain]').forEach((item) => {
                $(item).removeClass('hidden');
                if ($(item).attr('data-domain') !== domain && $(item).attr('data-domain') !== 'all') {
                    $(item).addClass('hidden');
                }
            })

            if (categorySelect.find("option[data-domain='" + domain + "']").length && domain!='all') {
                categorySelect.prop("disabled", false);
            }
    }

    return {
        init : () => {
            if ($(".filter-homepage-section").length) {
                initDomainSelect();
                initCategorySelect();
                checkSelectedOptions();
            }
        }
    }
})();
export default filterOurSolution;
